import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LISTADO_MENU } from '../../constants/menu.constant';
import { MenuService } from 'src/app/shared/services/menu.service';
import { environment } from 'src/environments/environment';
import { jwtDecode } from "jwt-decode";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit  {
  urlKeycloak: string = '';
  clientIdKeycloak: string = '';
  realmKeycloak: string = '';
  rolesUsuario = [];

  menu: any;
  @ViewChild('btnCollapsed') btnCollapsed: ElementRef;
  constructor(private menuService: MenuService) {
    this.urlKeycloak = environment.URL_KEYCLOAK;
    this.clientIdKeycloak = environment.CLIENT_ID_KEYCLOAK;
    this.realmKeycloak = environment.REALM_KEYCLOAK;
  }

  ngOnInit(): void {
    this.menu = LISTADO_MENU;
  }

  cerrarMenu() {
    console.log("CEREANDO MENU");
    const btn = this.btnCollapsed.nativeElement;
    const navBar = document.getElementById('navbarNavMinAmb');
    navBar.classList.remove('show');
    btn.classList.add('collapsed')
  }
  returnClassList(item: any) {
    if (item?.megaMenu === true) {
      return item?.megaMenu === true ? 'dropdown has-megamenu-menu-govco' : '';
    }
    else {
      return item?.children?.length > 0 ? 'dropdown' : '';
    }
  }


  onTokenResolved(token: any) {
    const decodedToken: any = jwtDecode(token?.detail);

    if (decodedToken?.resource_access['cima-ui']) {
      this.rolesUsuario = decodedToken?.resource_access['cima-ui']?.roles ?? [];
    }
    else {
      this.rolesUsuario = [];
    }
    this.menuService.actualizarRoles(this.rolesUsuario);
  }

  validateAccessMenu(item: any) {

    if (item?.rol == "" || !item?.rol) {
      return item?.visible ?? false;
    }

    if (this.rolesUsuario.some(elemento => item?.rol.includes(elemento))) {
      return true;
    }

    return false;

  }

  ngAfterViewInit() {
  
  }


}
